module.exports = __webpack_public_path__ + "img/setting.21b73491.svg";